module.exports = __webpack_public_path__ + "static/img/2.2ac2477.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner1/2.png
// module id = jw7b
// module chunks = 14